import { destroy, get, getOne, post, put } from "../apis/httpClient";

export const pagingIntroduce = (params) => get('/api/v1/achievement/paging',params)
export const detailIntroduce=(query)=>getOne(`/api/v1/achievement/detail/${query}`)
export const updateIntroduce=(body)=>put(`/api/v1/achievement/update`,body)
export const createIntroduce=(body)=>post(`/api/v1/achievement/create`,body)
export const deleteIntroduce = (body) => destroy(`/api/v1/achievement/delete`,body)